import EnterEmailAddress from "./EnterEmailAddress";
import OTPVerification from "./OTPVerification";
import CreatePassword from "./CreatePassword";
import { STEP_MODEL } from "../../Model/HomeModel";
import SuccessResetPassword from "./SuccessResetPassword";
import VerifyIdentity from "./VerifyIdentity";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */
const Steps = ({activeStep, email, handleSelectFlow, emptyFields, t, canResendOtp,stepModel,
                   minutes, handleValidateOtp, otp,handleResendOtp,
                   setOtp, handleSavePassword, password, setPassword,
                   confirmPassword, setConfirmPassword, setTouched,
                   barClass, allPassed, ruleList, ruleClass, passwordsMatch,
                   canSave, setIsValidOtp, isValidOtp, seconds,secretModal, setSecretModal,
                   secretKey, setSecretKey
}) => {

    const renderEmailOtp = () => {
        const STEPS = STEP_MODEL.EMAIL.STEPS;
        switch (activeStep) {
            case STEPS.OTP:
                return <OTPVerification t={t}
                                        stepModel={stepModel}
                                        email={email}
                                        minutes={minutes}
                                        seconds={seconds}
                                        canResendOtp={canResendOtp}
                                        handleValidateOtp={handleValidateOtp}
                                        otp={otp}
                                        handleResendOtp={handleResendOtp}
                                        setOtp={setOtp}
                                        setIsValidOtp={setIsValidOtp}
                                        emptyFields={emptyFields}
                                        isValidOtp={isValidOtp} />;
            case STEPS.CREATE_PASSWORD:
                return <CreatePassword t={t}
                                       handleSavePassword={handleSavePassword}
                                       password={password}
                                       setPassword={setPassword}
                                       confirmPassword={confirmPassword}
                                       setConfirmPassword={setConfirmPassword}
                                       setTouched={setTouched}
                                       barClass={barClass}
                                       allPassed={allPassed}
                                       ruleList={ruleList}
                                       ruleClass={ruleClass}
                                       passwordsMatch={passwordsMatch}
                                       canSave={canSave} />;
            case STEPS.SUCCESS:
                return <SuccessResetPassword email={email} t={t} secretModal={secretModal} setSecretModal={setSecretModal}
                                             secretKey={secretKey} setSecretKey={setSecretKey} setPassword={setPassword}/>;
            default:
                return null;
        }
    };

    const renderAppOtp = () => {
        const STEPS = STEP_MODEL.APP.STEPS;
        switch (activeStep) {
            case STEPS.OTP:
                return <OTPVerification t={t}
                                        stepModel={stepModel}
                                        email={email}
                                        minutes={minutes}
                                        seconds={seconds}
                                        canResendOtp={canResendOtp}
                                        handleValidateOtp={handleValidateOtp}
                                        otp={otp}
                                        handleResendOtp={handleResendOtp}
                                        setOtp={setOtp}
                                        setIsValidOtp={setIsValidOtp}
                                        emptyFields={emptyFields}
                                        isValidOtp={isValidOtp} />;
            case STEPS.CREATE_PASSWORD:
                return <CreatePassword t={t}
                                       handleSavePassword={handleSavePassword}
                                       password={password}
                                       setPassword={setPassword}
                                       confirmPassword={confirmPassword}
                                       setConfirmPassword={setConfirmPassword}
                                       setTouched={setTouched}
                                       barClass={barClass}
                                       allPassed={allPassed}
                                       ruleList={ruleList}
                                       ruleClass={ruleClass}
                                       passwordsMatch={passwordsMatch}
                                       canSave={canSave} />;
            case STEPS.SUCCESS:
                return <SuccessResetPassword email={email} t={t} secretModal={secretModal} setSecretModal={setSecretModal}
                                             secretKey={secretKey} setSecretKey={setSecretKey} setPassword={setPassword}/>;
            default:
                return null;
        }
    };

    const renderChoice = () => {
        const STEPS = STEP_MODEL.CHOICE.STEPS;
        switch (activeStep) {
            case STEPS.VALIDATED:
                return <VerifyIdentity t={t} onSelectFlow={handleSelectFlow} />;
            default:
                return null;
        }
    };

    return { renderEmailOtp, renderAppOtp ,renderChoice};
};

export default Steps;
